import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class DachJahr extends AbstractRequirementMapper {
  protected frontendKey = 'sanierungen.dachJahr';

  public getValues(): number[] {
    return super.getValues().map((v) => Number.parseInt(<string>v, 10));
  }
}
